import React, { useState, useEffect } from 'react';

const DeviceTest = ({ children }) => {
  const [isLaptop, setIsLaptop] = useState(true);

  useEffect(() => {
    const checkIsLaptop = () => {
      setIsLaptop(window.innerWidth >= 1024);
    };

    checkIsLaptop();

    window.addEventListener('resize', checkIsLaptop);

    return () => {
      window.removeEventListener('resize', checkIsLaptop);
    };
  }, []);

  return (
    <>
      {isLaptop ? children : <h1>Sorry, this app is only accessible on laptops/desktops.</h1>}
    </>
  );
};

export default DeviceTest;
